module.exports = __webpack_public_path__ + "static/media/live-code.2460c94d.jpg";